import { useNavigate, useParams } from "react-static-url-router";
import Box from "../components/layout/Box";
import { Loader } from "../components/primitives/Loader";
import { useResultQuery } from "../queries/integrations/back_end";
import { FormValues } from "./Form";

const Loading = () => {
  const { simulator_result,  request_id} = useParams() as { simulator_result: string, request_id: string};
  const formValues = simulator_result || "{}";
  const { data: algo_result } = useResultQuery({ values: formValues,  request_id});
  const parsedFormValues = JSON.parse(formValues) as FormValues;
  const navigate = useNavigate();

  if (algo_result) {
    const stringifiedFormValues = JSON.stringify(parsedFormValues);
    const stringifiedAlgoResult = JSON.stringify(algo_result);
    const params = new URLSearchParams({ request_id, algo_result: stringifiedAlgoResult, form_values: stringifiedFormValues});
    navigate(`/result?${params}`);
    return null
  } else {    
    return (
      <Box flexRatio={1} col>
        <Box flexRatio={1} col>
          <Box flexRatio={1} col justifyContent="center" alignItems="center">
          <Loader />
          </Box>
        </Box>
      </Box>
    )
  }
};

export { Loading }